import {endpoints} from './endpoints'
import request from '../../request'

export function create(data, onUploadProgress = null) {
	return new Promise((resolve, reject) => {
		request({
			url: endpoints.create,
			method: 'post',
			data,
			onUploadProgress
		})
			.then(async function (response) {
				resolve(response)
			})
			.catch(function (error) {
				reject(error)
			})
	})
}

export function update(data, onUploadProgress = null) {
	return new Promise((resolve, reject) => {
		request({
			url: endpoints.update,
			method: 'post',
			data,
			onUploadProgress
		})
			.then(async function (response) {
				resolve(response)
			})
			.catch(function (error) {
				reject(error)
			})
	})
}

export function deleteMeeting(data, onUploadProgress = null) {
	return new Promise((resolve, reject) => {
		request({
			url: endpoints.delete,
			method: 'post',
			data,
			onUploadProgress
		})
			.then(async function (response) {
				resolve(response)
			})
			.catch(function (error) {
				reject(error)
			})
	})
}

export function getMeeting(params) {
	return new Promise((resolve, reject) => {
		request({
			url: endpoints.getMeeting,
			method: 'get',
			params
		})
			.then(async function (response) {
				resolve(response)
			})
			.catch(function (error) {
				reject(error)
			})
	})
}

export function getMyMeetingsByProject(params) {
	return new Promise((resolve, reject) => {
		request({
			url: endpoints.getMyMeetingsByProject,
			method: 'get',
			params
		})
			.then(async function (response) {
				resolve(response)
			})
			.catch(function (error) {
				reject(error)
			})
	})
}

export function addInteraction(data) {
	return new Promise((resolve, reject) => {
		request({
			url: endpoints.addInteraction,
			method: 'post',
			data
		})
			.then(async function (response) {
				resolve(response)
			})
			.catch(function (error) {
				reject(error)
			})
	})
}


export function markMeetingAsRead(data) {
        return new Promise((resolve, reject) => {
                request({
                        url: endpoints.markMeetingAsRead,
                        method: 'post',
                        data
                })
                        .then(async function (response) {
                                resolve(response)
                        })
                        .catch(function (error) {
                                reject(error)
                        })
        })
}

export function changeVisualizationStatus(data) {
	return new Promise((resolve, reject) => {
		request({
			url: endpoints.changeVisualizationStatus,
			method: 'post',
			data
		})
			.then(resolve)
			.catch(reject)
	})
}
export function getPdf(params) {
	return new Promise((resolve, reject) => {
		request({
			url: endpoints.getPdf,
			method: 'get',
			params
		})
			.then(async function (response) {
				resolve(response)
			})
			.catch(function (error) {
				reject(error)
			})
	})
}

export function downloadPdf(params) {
	return new Promise((resolve, reject) => {
		request({
			url: endpoints.downloadPdf,
			method: 'get',
			params,
			responseType: 'arraybuffer'
		})
			.then(async function (response) {
				resolve(response)
			})
			.catch(function (error) {
				reject(error)
			})
	})
}

export function sendEmail(data) {
	return new Promise((resolve, reject) => {
		request({
			url: endpoints.sendPdfEmail,
			method: 'post',
			data
		})
			.then(async function (response) {
				resolve(response)
			})
			.catch(function (error) {
				reject(error)
			})
	})
}